/* eslint-disable no-console */
// logs to the console if localStorage.debug === 'true'
// testers will have a bookmarklet to toggle debug mode
// or you can just run localStorage.setItem('debug', 'true') in the browser console
export const logger = (...args) =>
  localStorage.getItem('debug') === 'true' ? console.log(...args) : () => {}
